import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Avatar, Link } from '@mui/material';
import CarnetVirtualService from '../../services/CarnetVirtualService';

const carnetService = new CarnetVirtualService();

interface PerfilCardProps {
  avatarUrl: string;
  name: string;
  cargo: string;
  email?: string;
}

export const AvatarCard: React.FC<PerfilCardProps> = ({ avatarUrl, name, email= "", cargo }) => {
    let [imagen,setImagen] = useState("");
    
    useEffect(() => {
        if(avatarUrl === "" && email !==""){
            let mail = email.split('@');
            let resp = carnetService.GetFotoString(mail[0]).then((data) => {
                //console.log(data.fotoString);
                setImagen(data.fotoString);
              })
              .catch((err) => {
                setImagen(avatarUrl);
                console.error('Error al obtener los datos del usuario', err);
              });
        }
    }, []);

  return (
    <Card sx={{ display: 'flex', alignItems: 'center' }}>
      <Avatar
        alt={name}
        src={imagen}
        sx={{ width: 56, height: 56, margin: 2 }}
      />
      <CardContent sx={{ flex: '1', padding: 2 }}>
        <Typography variant="h6" component="div">
          {name}
        </Typography>
        <Typography variant="body2" color="textSecondary">
            <strong>{cargo}</strong>
        </Typography>
        {email === "" ? 
        <Typography variant="body2" color="textSecondary">
                {"            "}
        </Typography>
        :
        <Typography variant="body2" color="textSecondary">
            <Link href={"mailto:"+{email}} underline="hover">
                {email}
            </Link>
        </Typography>
        }        
      </CardContent>
    </Card>
  );
};
